module.exports = __webpack_public_path__ + "img/2-low.642470c8.jpg";